import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ApiExError } from '@shared';

const openAiCompletionSlice = createSlice({
  name: 'openAiCompletion',
  initialState: initialState.openAiCompletion,
  reducers: {
    // API triggers (for saga/middleware)
    postOpenAiCompletionRequest: (state, action: PayloadAction<OpenAiCompletionRequest>) => {
      state.currentRequestId = action.payload.requestId || null;
    },
    // Empty - completion data is handled via fetchOpenAi...Response polling
    postOpenAiCompletionResponse: () => {},
    postOpenAiCompletionFailure: (state, action: PayloadAction<ApiExError>) => {
      const requestId = state.currentRequestId;
      if (requestId) {
        state.errors[requestId] = action.payload;
      }
    },

    // Empty - just triggers API call via middleware/saga
    fetchOpenAiCompletionByRequestIdRequest: (
      state,
      action: PayloadAction<OpenAiCompletionRequestIdProp>,
    ) => {},
    fetchOpenAiCompletionByRequestIdResponse(
      state,
      action: PayloadAction<OpenAiCompletionDbRecord>,
    ) {
      state.completions[action.payload.requestId] = action.payload;
    },
    fetchOpenAiCompletionByRequestIdFailure: (state, action: PayloadAction<ApiExError>) => {
      const requestId = state.currentRequestId;
      if (requestId) {
        state.errors[requestId] = action.payload;
      }
    },

    clearOpenAiCompletion(state, action: PayloadAction<string>) {
      delete state.completions[action.payload];
    },
    resetOpenAiCompletionState: state => {
      state.completions = {};
      state.errors = {};
      state.currentRequestId = null;
    },
  },
});

export const {
  postOpenAiCompletionRequest,
  postOpenAiCompletionResponse,
  postOpenAiCompletionFailure,
  fetchOpenAiCompletionByRequestIdRequest,
  fetchOpenAiCompletionByRequestIdResponse,
  fetchOpenAiCompletionByRequestIdFailure,
  clearOpenAiCompletion,
  resetOpenAiCompletionState,
} = openAiCompletionSlice.actions;

export const openAiCompletionSliceReducer = openAiCompletionSlice.reducer;
